export default __webpack_public_path__ + "static/media/cerebrisans-medium.249b54ef.woff";